import { useTranslation } from "react-i18next";
import { Widget } from "datastake-daf/dist/components";
import styled from "styled-components";

const Style = styled.div`
  height: 280px;
  background-image: url('/assets/images/find-information/graphs.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
`;

export default function Graph({ loading }) {
  const { t } = useTranslation();

  return (
    <Widget
      loading={loading}
      title={t('Associations Graph')}
      className="with-border-header flex-1 no-p-body"
    >
      <Style />
    </Widget>
  );
}
